import styled, { createGlobalStyle } from "styled-components";

export const CustomGenericListStyle = createGlobalStyle`
  #main-content {
    overflow: hidden;
  }
`;

export const MainWrapper = styled.div`
  padding-inline: 50px;
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 100px);
  overflow: hidden;
`;

export const HeaderFiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  min-height: 0;
  position: relative;
`;

export const DepartmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px 0;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const DepartmentsGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  width: 100%;

  @media (max-width: 1280px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;

export const PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 0;
  background: ${(props) => props.theme.colors.background || "#ffffff"};
  position: sticky;
  bottom: 0;
  z-index: 10;
`;
